import React, { useEffect, useState, useRef, createRef } from "react";
import Topbar from "../Components/Structure/Topbar";
import { Grid, Typography, TextField } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import FitlerModal from "../Components/History/FilterModal";
import moment from "moment";
import { MobileDatePicker } from "@mui/x-date-pickers/MobileDatePicker";
import AlertComponent from "../Components/Structure/AlertComponent";
import { getHistoryApi } from "../Apis/Endpoints/HistoryApi";
import { useSelector } from "react-redux";
import AlertApiResult from "../Components/Structure/AlertApiResult";
import NotFound from "../Components/Structure/NotFound";
import HistoryTable from "../Components/Tables/HistoryTable";
import BackButton from "../Components/Structure/BackButton";
import { useTranslation } from "react-i18next";

function History() {
  // 1) Data

  const theme = useTheme();
  const { t } = useTranslation();
  const DateFromInput = useRef();
  const DateToInput = useRef();
  const LoginSettings = useSelector((state) => state.LoginSettings.value);
  const Account = useSelector((state) => state.Account.value);
  const [date, setdate] = useState(
    moment().subtract(1, "month").format(" D MMMM YYYY")
  );
  const [dateFromCalendar, setdateFromCalendar] = useState(
    moment().subtract(1, "month").format(" D MMMM YYYY")
  );
  const [dateTo, setdateTo] = useState(
    moment().add(1, "day").format("D MMMM YYYY")
  );
  const [dateToCalendar, setdateToCalendar] = useState(
    moment().add(1, "day").format("D MMMM YYYY")
  );
  const [errorMessage, seterrorMessage] = useState("Error");
  const [showError, setshowError] = useState(false);
  const [callApiStatus, setcallApiStatus] = useState("");
  const [dataArray, setdataArray] = useState([]);

  // 2) UseEffect
  useEffect(() => {
    if (!showError) getHistory();
    return;
  }, [date, dateTo]);

  // 3) Functions
  const handleChangeDateFrom = (newValue) => {
    let d = moment(newValue).format("D MMMM YYYY");
    setdateFromCalendar(d);
    setdate(d);
    checkDatesFrom(newValue);
  };
  const handleChangeDateTo = (newValue) => {
    let d = moment(newValue).format("D MMMM YYYY");
    setdateToCalendar(d);
    setdateTo(d);
    checkDatesTo(newValue);
  };

  function openDateFrom() {
    DateFromInput.current.click();
  }

  function openDateTo() {
    DateToInput.current.click();
  }

  const getHistory = () => {
    let startDate = date;
    let toDate = dateTo;

    getHistoryApi(
      LoginSettings.web_server_url,
      startDate,
      toDate,
      Account.token
    ).then((response) => {
      if (response.data.result.resultCode === 0) {
        let calls = response.data.response.calls;
        //console.log("Calls Array : ", calls);
        setdataArray(calls);
        // setloading(false);
      } else {
        console.log("Error while trying to get calls");
      }
    });
  };

  const checkDatesFrom = (newValue) => {
    let check = newValue.isBefore(dateTo);
    if (check) {
      setshowError(false);
      setcallApiStatus("Success");
    } else {
      seterrorMessage("Please set correct dates");
      setcallApiStatus("Error");
      setshowError(true);
      setdataArray([]);
    }
  };
  const checkDatesTo = (newValue) => {
    let check = newValue.isAfter(date);
    if (check) {
      setshowError(false);
      setcallApiStatus("Success");
    } else {
      seterrorMessage("Please set correct dates");
      setcallApiStatus("Error");
      setshowError(true);
      setdataArray([]);
    }
  };

  return (
    <>
      {showError && (
        <AlertApiResult
          message={errorMessage}
          status={callApiStatus}
          setClose={setshowError}
        />
      )}
      <Topbar page="History" />

      {/* Header */}
      <div className="text-center mt-3">
        <p className=" text-3xl  Primary_Main_Text">{t("ΙΣΤΟΡΙΚΟ_ΚΛΗΣΕΩΝ")}</p>
      </div>

      {/* Dates */}
      <div className="text-lg text-center justify-center mx-auto sm:flex mb-3 mt-3">
        {/* From */}
        <div className="sm:flex justify-center items-center sm:mr-2">
          <Typography
            variant="h6"
            style={{
              fontWeight: "lighter ",
              marginRight: 10,
            }}
          >
            {t("Από")}
          </Typography>
          <div
            onClick={openDateFrom}
            className=" GlassEffectButton Primary_Light_Background px-4 m-auto py-1 justify-center rounded text-base text w-max cursor-pointer active:bg-gray-300 "
          >
            {date}
          </div>
        </div>

        {/* To */}
        <div className="sm:flex justify-center items-center sm:ml-2">
          <Typography
            variant="h6"
            style={{
              fontWeight: "lighter ",
              marginRight: 10,
            }}
          >
            {t("Μέχρι")}
          </Typography>
          <div
            onClick={openDateTo}
            className=" GlassEffectButton px-4 py-1 m-auto rounded Primary_Light_Background text-base text w-max cursor-pointer active:bg-gray-300 "
          >
            {dateTo}
          </div>
        </div>
      </div>

      {/* Total Calls */}
      <div className="text-center">
        <Typography
          variant="h6"
          style={{
            fontWeight: "lighter ",
          }}
        >
          {t("Αριθμός_κλήσεων")} {" : "} {dataArray.length}
        </Typography>{" "}
      </div>

      {/* Datatable */}
      <div className=" max-w-3xl m-auto px-3 pt-3 pb-10 mb-1">
        {dataArray.length > 0 ? (
          <>
            <HistoryTable data={dataArray} />
          </>
        ) : (
          <NotFound text={t("Unfortunately,no_data_found_with_given_dates.")} />
        )}
      </div>

      {/* Date Inputs */}
      <div className="hidden">
        <MobileDatePicker
          label="Date From"
          inputFormat="MM/DD/YYYY"
          value={dateFromCalendar}
          onChange={handleChangeDateFrom}
          renderInput={(params) => (
            <TextField
              {...params}
              fullWidth
              size="small"
              inputRef={DateFromInput}
            />
          )}
        />
        <MobileDatePicker
          label="Date To"
          inputFormat="MM/DD/YYYY"
          value={dateToCalendar}
          onChange={handleChangeDateTo}
          renderInput={(params) => (
            <TextField
              {...params}
              fullWidth
              size="small"
              inputRef={DateToInput}
            />
          )}
        />
      </div>

      {/* Back Button */}
      <div className="block sm:hidden">
        <BackButton />
      </div>
    </>
  );
}

export default History;
